import { render, staticRenderFns } from "./modalNotasEdit.vue?vue&type=template&id=157096dd&"
import script from "./modalNotasEdit.vue?vue&type=script&lang=js&"
export * from "./modalNotasEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports